module.exports = __webpack_public_path__ + "img/pager7img.230b1bb1.png";